module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-05-46aa70b49493efc6e7c9395690c9c5ec.svg";